import { NgModule, ModuleWithProviders } from "@angular/core";
import { CommonModule } from "@angular/common";
import { StoreModule } from "@ngrx/store";
import { EffectsModule } from "@ngrx/effects";

import { FontAwesomeModule } from "@fortawesome/angular-fontawesome";
import { NgxSafePipesModule } from "@it-era/ngx-safe-pipes";

import { CoreModule } from "src/app/core/core.module";

import { SERVICES } from "./services";
import { COMPONENTS } from "./components";
import { CatalogRoutingModule } from "./catalog-routing.module";

@NgModule({
  providers: [...SERVICES],
  exports: [...COMPONENTS, StoreModule, EffectsModule],
  imports: [
    CommonModule,
    FontAwesomeModule,
    NgxSafePipesModule,
    CoreModule,
    CatalogRoutingModule,
    ...COMPONENTS,
  ],
})
export class CatalogModule {
  static forRoot(): ModuleWithProviders<CatalogModule> {
    return {
      ngModule: CatalogModule,
      providers: [],
    };
  }
}
